import { masterApiService } from 'api/config'
import { Setting } from 'types/setting'
import { useQuery } from '@tanstack/react-query'

export const SETTINGS_QUERY_KEY = 'setting'

export const fetchSetting = async () => {
  const response = await masterApiService.getList<Setting>('settings')
  return response[0]
}

export const useGetSetting = () => {
  const { data, ...result } = useQuery({
    queryKey: [SETTINGS_QUERY_KEY],
    queryFn: fetchSetting,
    // Considera i dati "freschi" per 2 minuti
    staleTime: 2 * 60 * 1000,
    // Mantiene i dati in cache per 5 minuti
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })

  return {
    setting: data,
    colors: {
      primary: data?.primaryColor,
      secondary: data?.secondaryColor,
    },
    title: data?.portal?.title ?? 'Mimir',
    description: data?.portal?.description ?? 'Your smart assistance',
    ...result,
  }
}
